import * as React from 'react';

import { Action, Item, List, Wrapper } from './wrapper';

export interface ITabItem {
  name: string;
  displayName: string;
  count?: string;
  onClick: () => void;
}

export interface ITabInterface {
  tabs: ITabItem[];
  active: string;
}

const Tabs = ({ tabs, active }: ITabInterface) => (
  <Wrapper>
    <List>
      {tabs.map((tab) => {
        const isSelected = tab.name === active;
        return (
          <Item key={tab.name}>
            <Action
              title={tab.displayName}
              onClick={tab.onClick}
              aria-selected={isSelected}
              $isActive={isSelected ? 'true' : undefined}
            >
              {tab.displayName}
              {tab.count !== undefined ? ` (${tab.count})` : undefined}
            </Action>
          </Item>
        );
      })}
    </List>
  </Wrapper>
);

export default Tabs;
